export type GuidePlatform = 'web' | 'shopee' | 'tiktok' | 'lazada'

export interface PlatformGuide {
  /** Tên sàn hiển thị trong câu "Cách lấy mã đơn hàng trên ..." */
  displayName: string
  /** Path CDN icon sàn. Web dùng icon Globe của lucide nên để trống */
  iconPath?: string
  steps: string[]
  /** Bước hiển thị trong popup, mặc định dùng lại `steps` */
  detailSteps?: string[]
  exampleText: string
  exampleCode: string
  /** 3 ảnh minh họa theo thứ tự các bước */
  imagePaths: string[]
}

export const GUIDE_PLATFORMS: GuidePlatform[] = [
  'web',
  'shopee',
  'tiktok',
  'lazada',
]

export const PLATFORM_TAB_LABEL: Record<GuidePlatform, string> = {
  web: 'WEB',
  shopee: 'SHOPEE',
  tiktok: 'TIKTOKSHOP',
  lazada: 'LAZADA',
}

export const PLATFORM_GUIDES: Record<
  Exclude<GuidePlatform, 'web'>,
  PlatformGuide
> = {
  shopee: {
    displayName: 'Shopee',
    iconPath: '/image/2026/09/25/doi-tra-icon-shopee.png',
    steps: [
      'Vào ứng dụng Shopee > chọn mục Tôi > Đơn mua',
      'Chọn đơn hàng bạn muốn đổi trả',
      'Kéo xuống phần Thông tin đơn hàng > Tìm dòng Mã đơn hàng > nhấn Sao chép.',
    ],
    exampleText: 'Mã đơn hàng Shopee có dạng tương tự:',
    exampleCode: '260923XXXXXX',
    imagePaths: [
      '/image/2026/09/25/doi-tra-guide-shopee-1.png',
      '/image/2026/09/25/doi-tra-guide-shopee-2.png',
      '/image/2026/09/25/doi-tra-guide-shopee-3-v2.png',
    ],
  },
  tiktok: {
    displayName: 'Tiktokshop',
    iconPath: '/image/2026/09/25/doi-tra-icon-tiktok.png',
    steps: [
      'Vào ứng dụng TikTok > chọn Cửa hàng > Chọn Đơn hàng',
      'Chọn đơn hàng bạn muốn đổi trả',
      'Tìm mục Số đơn hàng > nhấn Sao chép',
    ],
    detailSteps: [
      'Vào ứng dụng TikTok > chọn Cửa hàng > Chọn Đơn hàng',
      'Tìm đơn hàng Coolmate cần lấy mã > Ấn vào sản phẩm ở đơn hàng đã đặt',
      'Tìm mục Số đơn hàng > nhấn Sao chép',
    ],
    exampleText: 'Mã đơn hàng TikTokShop là dãy số 18 ký tự, có dạng tương tự:',
    exampleCode: '5XXXXXXXXXXXXXXXXX',
    imagePaths: [
      '/image/2026/09/25/doi-tra-guide-tiktok-1.png',
      '/image/2026/09/25/doi-tra-guide-tiktok-2.png',
      '/image/2026/09/25/doi-tra-guide-tiktok-3.png',
    ],
  },
  lazada: {
    displayName: 'Lazada',
    iconPath: '/image/2026/09/25/doi-tra-icon-lazada.png',
    steps: [
      'Vào ứng dụng Lazada > Vào mục Tài khoản > Đơn hàng của tôi',
      'Chọn đơn hàng bạn muốn đổi trả',
      'Kéo xuống phần Thông tin đơn hàng > Tìm dòng Mã đơn hàng > nhấn Sao chép.',
    ],
    detailSteps: [
      'Vào ứng dụng Lazada > Vào mục Tài khoản > Đơn hàng của tôi',
      'Chọn đơn hàng Coolmate cần lấy mã',
      'Kéo xuống phần Thông tin đơn hàng > Tìm dòng Mã đơn hàng > nhấn Sao chép.',
    ],
    exampleText: 'Mã đơn hàng Lazada là dãy số 15 ký tự, có dạng tương tự:',
    exampleCode: '5XXXXXXXXXXXXXX',
    imagePaths: [
      '/image/2026/09/25/doi-tra-guide-lazada-1.png',
      '/image/2026/09/25/doi-tra-guide-lazada-2.png',
      '/image/2026/09/25/doi-tra-guide-lazada-3.png',
    ],
  },
}
